import { Sliders } from 'react-feather'

// 'manage all' is the super admin role (sadmin); nobody else sees it.
export default [
  {
    id: 'configurations',
    title: 'Configurations',
    icon: <Sliders size={20} />,
    navLink: '/configurations',
    action: 'manage',
    resource: 'all'
  }
]
